import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideZoneChangeDetection } from "@angular/core";
import { PreloadAllModules, provideRouter, Router, RouteReuseStrategy, withPreloading } from "@angular/router";
import { AndroidPermissions } from "@ionic-native/android-permissions/ngx";
import { routes } from "./app.routes";
import * as Sentry from "@sentry/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { Vibration } from "@awesome-cordova-plugins/vibration/ngx";
import { IonicRouteStrategy, provideIonicAngular } from "@ionic/angular";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from "@angular/common/http";
import { AFS_THEME_DARK_MOBILE, provideAFS } from "@afs-ng/core";
import { AFS_THEME_OVERRIDE } from "./services/darkmode.service";
import { HttpError } from "./interceptors/httperror.interceptor";
import { NativeStorage } from "@ionic-native/native-storage/ngx";
import { ThemeDetection } from "@ionic-native/theme-detection/ngx";
import { TapticEngine } from "@awesome-cordova-plugins/taptic-engine/ngx";
import { Zeroconf } from "@awesome-cordova-plugins/zeroconf/ngx";

export const appConfig: ApplicationConfig = { providers: [
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideZoneChangeDetection(),
    provideAppInitializer(() => { inject(Sentry.TraceService); }),
    provideIonicAngular(),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: HttpError, multi: true },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false }) },
    { provide: Sentry.TraceService, deps: [Router] },
    provideAFS({
        theme: {
            preset: AFS_THEME_DARK_MOBILE,
            override: AFS_THEME_OVERRIDE
        }
    }),
    SplashScreen,
    Vibration,
    NativeStorage,
    ThemeDetection,
    AndroidPermissions,
    TapticEngine,
    Zeroconf
]}